import React, {useEffect, useState} from "react";
import isTokenExpired from "./isTokenExpired";
import { Navigate } from "react-router";
import "../../Styles/Components/PublicForms/Header.css";
import headerLogo from "../../Images/headerLogo.png";
import iconMenu from '../../Images/iconMenu.png';


const Header = (props) => {
  
  const[width, setWidth] = useState(0);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    
    window.addEventListener("resize", handleResize)
    
    handleResize()
    
    
  }, []);


  

  return (
    <>
      <header className="sticky-header">
        <div className="topnav" id="myTopnav">
          <div className="header_details_tablet_up">

            <a href="#"> <img className="logoHeader" src = {headerLogo} /> </a>
            {/* <a href="#">میز کار</a> */}
            {width< 1000 ?<a href="#" onClick={()=>props.handleNave()}><img className="loginLogo" src = {iconMenu} /> </a>: null}
            <p>برنامه اشتراک موسسه فرهنگی موعود عصر(عج)</p>
          </div>


          
            
        </div>

      </header>
    </>
    
  );
};

export default Header;
